/*
 * @copyright Copyright (c) valantic CEC Deutschland GmbH (https://www.valantic.com)
 * @see PROJECT_LICENSE.txt
 */

import { getGenderLabelByKey } from '../../api/request'

const liveSearchHelperHeading = {
    fallbackHeadingActive: false,
    headingTranslations: window.liveSearchConfig.headingTranslations || {},
    /**
     * Dispatch heading update event with provided heading text
     *
     * @param {string|null} headingText
     * @param {boolean} isFallback
     */
    dispatchHeadingUpdate(headingText = null, isFallback = false) {
        window.dispatchEvent(new CustomEvent('live-search-heading-update', {
            detail: {
                heading: headingText,
                isFallback
            }
        }))
    },
    /**
     * Build fallback heading using translation template and gender meta
     *
     * @param {Object} genderMeta
     * @returns {string}
     */
    getFallbackHeading(genderMeta) {
        const primaryLabel = getGenderLabelByKey(genderMeta.primaryGenderKey)
        const fallbackLabel = getGenderLabelByKey(genderMeta.usedGenderKey)
        const template = this.headingTranslations.fallbackHeading ||
            'No results for %1. Search results for %2: %3'

        return template
            .replace('%1', primaryLabel)
            .replace('%2', fallbackLabel)
            .replace('%3', this.searchPhrase || '')
    },
    /**
     * Build heading for current gender context
     *
     * @param {Object} genderMeta
     * @returns {string}
     */
    getResultsHeading(genderMeta) {
        const activeLabel = getGenderLabelByKey(genderMeta.usedGenderKey)
        const template = this.headingTranslations.resultsHeading || 'Search results in %1: %2'

        return template
            .replace('%1', activeLabel)
            .replace('%2', this.searchPhrase || '')
    },
    /**
     * Update heading text when fallback results are shown
     *
     * @param {Object|null} genderMeta
     */
    applyFallbackHeading(genderMeta) {
        if (genderMeta?.usedGenderKey) {
            const activeLabel = getGenderLabelByKey(genderMeta.usedGenderKey)
            if (!activeLabel) {
                this.resetHeading()
                return
            }

            const updatedHeading = genderMeta.fallbackHasResults && genderMeta.primaryGenderKey
                ? this.getFallbackHeading(genderMeta)
                : this.getResultsHeading(genderMeta)

            if (updatedHeading) {
                this.dispatchHeadingUpdate(updatedHeading, Boolean(genderMeta?.fallbackHasResults))
                this.fallbackHeadingActive = Boolean(genderMeta?.fallbackHasResults)
                return
            }
        }

        this.resetHeading()
    },
    /**
     * Reset heading to its default text
     */
    resetHeading() {
        this.dispatchHeadingUpdate(null, false)
    }
}

export default liveSearchHelperHeading
